import { BILLING_API } from '@Constants/backendConstants';
import { useReadOnlyEntityAttachments } from '@Hooks/Attachments/useReadOnlyEntityAttachments';

/** Read-only per-invoice-snapshot attachments (redirected to the source invoice). */
export function useInvoiceSnapshotAttachments(invoiceSnapshotId: string | undefined) {
    return useReadOnlyEntityAttachments(BILLING_API, 'invoice_snapshots', invoiceSnapshotId);
}
